export const renderMessagePreview = (template, contact = {}) => {
    if (!template) return template;
    const firstName = contact.firstName ?? contact.fname ?? '';
    const lastName  = contact.lastName ?? contact.lname ?? '';
    const email     = contact.email ?? '';
    return template
        .replace("$first_name", firstName)
        .replace("$last_name", lastName)
        .replace("$email", email)
        .replace("%FIRSTNAME%", firstName)
        .replace("%LASTNAME%", lastName)
        .replace("%EMAIL%", email);
};
